import React from 'react'
import {PiCheckCircleFill} from "react-icons/pi";
import { SlDoc } from "react-icons/sl";
import { IoChatbubblesOutline } from "react-icons/io5";
import { HiOutlineStar } from "react-icons/hi";
import { FiCheckSquare } from "react-icons/fi";

interface Props {}

// 根据模板 value（中文）映射图标
const templateIconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  '深度纪要': SlDoc,
  '对话式纪要': IoChatbubblesOutline,
  '关键点式纪要': HiOutlineStar,
  '任务分配': FiCheckSquare,
};

const TemplateCard = ({img, title, value ,sk, desc, curKey, More}) => {

    // const location = useLocation();
    // const query = new URLSearchParams(location.search);
    // const isDebug = query.get("isDebug");
    //
    // const { user, isAuthenticated, isLoading, logout, loginWithRedirect } = useAuth0();
    // const { data, runFetch } = useSnapshot(VIPStore);
    // console.log(20, data);
    const isSelect = value === curKey;
    const IconComponent = templateIconMap[value] || SlDoc;

  return (
    <>
        <div className={`border rounded-2xl p-5 flex flex-col group/card cursor-pointer transition-all
        ${isSelect ? "border-black shadow-lg" : "border-[#E9E9E7] hover:border-[#D1D1CF]"}
        `}

        onClick={() => {sk(value)}}
        >
            {/* 图片占位区域 - 用图标代替，和场景模式一致 */}
            <div className="w-full aspect-[4/3] bg-[#F7F7F5] rounded-xl overflow-hidden mb-4 flex items-center justify-center">
                <IconComponent className="text-4xl text-[#91918E] opacity-60 group-hover/card:scale-105 transition-transform duration-700" />
            </div>
            <div>
                <div className="flex items-center gap-1.5 mb-1">
                    <h3 className="text-sm font-bold">{title}</h3>
                    {isSelect && <PiCheckCircleFill className={"text-base text-[#4B5563]"}/>}
                </div>
                <p className="text-[11px] text-[#91918E] leading-relaxed">{desc}</p>
                {
                    More !== null &&
                    <More/>
                }
            </div>
        </div>
    </>
  )
}

export default TemplateCard
